import { Typography, useTheme, Box } from '@mui/material'
import Grid from '@mui/material/Grid'
import { DisplayBarBackground } from 'components/atoms/ShadedScoreDisplayBar'
import { CircleNumber } from 'components/atoms/Text'
import InCardStack from 'components/atoms/container/InCardStack'
import RowStack from 'components/atoms/container/RowStack'
import { useTranslation } from 'react-i18next'
import colors from 'styles/colors'

const StepQuizSurveyResult = ({ resultData }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const ColStack = ({ children, ...otherProps }) => (
    <InCardStack alignItems={'flex-start'} width={'100%'} {...otherProps}>
      {children}
    </InCardStack>
  )

  const SurveyScore = ({ score }) => (
    <Grid display='inline-flex' justifyContent='right'>
      <CircleNumber
        value={score.toFixed(1)}
        color={colors.MutedTeal200}
        border={`2px solid ${colors.MutedTeal400}`}
        variant='h3'
        size={48}
      />
    </Grid>
  )

  return (
    <InCardStack spacing={8} sx={{ alignItems: 'left' }}>
      {resultData.map(
        ({ name, score, description, highLowMsg, resultMessage }) => (
          <DisplayBarBackground
            key={name}
            width='100%'
            height='fit-content'
            sx={{
              padding: 8,
              borderRadius: 4
            }}>
            <ColStack spacing={6}>
              <RowStack
                spacing={8}
                alignItems={'flex-start'}
                justifyContent={'space-between'}>
                <ColStack spacing={2} flex={1}>
                  <Typography variant='h4'>{name}</Typography>

                  <Typography>{description}</Typography>
                </ColStack>
                <SurveyScore score={score} />
              </RowStack>

              {(highLowMsg || resultMessage) && (
                <Box
                  sx={{
                    paddingX: 8,
                    borderLeft: 4,
                    borderColor: theme.palette.primary.main,
                    flex: 1
                  }}>
                  <ColStack spacing={4}>
                    {highLowMsg && <Typography variant='body1Bold'>
                      {t('stepQuiz.youScored')} {highLowMsg.type}{' '}
                      {t('stepQuiz.on')} {name}
                    </Typography>}
                    <Typography style={{ whiteSpace: 'pre-line' }}>{resultMessage || highLowMsg.message}</Typography>
                  </ColStack>
                </Box>
              )}
            </ColStack>
          </DisplayBarBackground>
        )
      )}
    </InCardStack>
  )
}
export default StepQuizSurveyResult
